/* @flow */
import styled from "styled-components";

const StyledTitle = styled.h2`
  font-size: ${props => props.theme.global.typography.h2.fontSize};
  font-weight: ${props => props.theme.global.typography.h2.fontWeight};
  line-height: ${props => props.theme.global.typography.lineHeight.title};
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    margin-bottom: ${props => props.theme.global.padding.small};
  }

  @media (min-width: ${props => props.theme.global.breakpoints.medium.value}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${props => props.theme.global.padding.medium};
  }
`;

const StyledContentWrapper = styled.div`
  border: ${props => props.theme.global.border.size.xsmall} solid
    ${props => props.theme.global.colors.border.light};
  border-radius: ${props => props.theme.global.border.radius.medium};
  box-shadow: ${props =>
    props.elevated ? props.theme.global.elevation.light.medium : "none"};
  padding: ${props => props.theme.global.padding.medium};
  background: ${props => props.theme.global.colors.white};
  overflow-x: auto;
`;

const StyledActionContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;

  & > *:not(:first-child) {
    margin-left: ${props => props.theme.global.padding.small};
  }

  @media (min-width: ${props => props.theme.global.breakpoints.medium.value}) {
    & > * {
      margin-left: ${props => props.theme.global.padding.small};
    }
  }
`;

export default {
  Title: StyledTitle,
  Header: StyledHeader,
  ContentWrapper: StyledContentWrapper,
  ActionContainer: StyledActionContainer
};
